module.exports = __webpack_public_path__ + "js/0-18790e427401645caf4c.chunk.worker.js"